module.exports = __webpack_public_path__ + "static/media/How To Identify Leopards.d0a3b125.png";